// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc7248b1","455":"89d486a9","488":"8d62a902","554":"bb44b81f"}[chunkId] + ".chunk.js";
};